import { ContextMenuVariantType } from '../../../../../../components/contextMenu/types/contextMenuVariantType';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../variants';
export const getRegularStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [ContextMenuVariantType.REGULAR]: {
            container: {
                display: 'flex',
                flex_direction: 'column',
                padding: FOUNDATIONS.spacing_250,
                box_shadow: SHADOWS.shadow_30,
                min_width: '220px',
                max_width: '320px',
                align_items: 'center',
                border_radius: FOUNDATIONS.radius_comp_containers_contextmenu_radiussize,
                background_color: FOUNDATIONS.color_comp_containers_bg,
            },
            closeIconContainer: {
                display: 'flex',
                justify_content: 'flex-end',
            },
            closeIcon: {
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
                color: FOUNDATIONS.color_comp_actions_closebutton_primary_default_icon,
            },
            titleContainer: {
                display: 'flex',
                justify_content: 'flex-start',
            },
            title: {
                font_variant: TextVariantType.FONT_TITLE_50,
                font_weight: FONT_WEIGHT.font_weight_600,
                color: FOUNDATIONS.color_neutral_font_50,
            },
            contentContainer: {
                width: '100%',
            },
            headerContainer: {
                display: 'flex',
                flex_direction: 'column',
                width: '100%',
                margin_bottom: FOUNDATIONS.spacing_250,
            },
        },
    };
};
//# sourceMappingURL=regular.js.map